import { deleteApp, initializeApp } from 'firebase/app';
import { connectFirestoreEmulator, initializeFirestore, memoryLocalCache, terminate } from 'firebase/firestore';

import getConfig from 'widget/helpers/config';

let app;
let firestore;

async function initializeFirebase() {
  const config = getConfig();

  app = initializeApp(config.globalConfig.FIREBASE_CONFIG, {
    name: `${config.webChannel.tenantId}-${config.webChannel.widgetId}`,
    automaticDataCollectionEnabled: false,
  });

  firestore = initializeFirestore(app, {
    localCache: memoryLocalCache(),
  });

  if (config.globalConfig.IS_DEV) {
    connectFirestoreEmulator(firestore, 'localhost', 8082);
  }
}

export async function stopFirebase() {
  if (firestore) {
    await terminate(firestore);

    firestore = undefined;
  }

  if (app) {
    await deleteApp(app);

    app = undefined;
  }
}

export async function startFirebase() {
  await stopFirebase();
  await initializeFirebase();

  return {
    app,
    firestore,
  };
}
